import { produce } from "immer";
import {
  FETCH_AI_WALLETS,
  FETCH_AI_WALLETS_SUCCESS,
  FETCH_AI_WALLETS_FAILURE,
  FETCH_AI_LEDGER,
  FETCH_AI_LEDGER_SUCCESS,
  FETCH_AI_LEDGER_FAILURE,
  FETCH_AI_PLANS,
  FETCH_AI_PLANS_SUCCESS,
  FETCH_AI_PLANS_FAILURE,
  START_AI_CHECKOUT,
  START_AI_CHECKOUT_SUCCESS,
  START_AI_CHECKOUT_FAILURE,
  COMPLETE_AI_CHECKOUT,
  COMPLETE_AI_CHECKOUT_SUCCESS,
  COMPLETE_AI_CHECKOUT_FAILURE,
} from "./constants";

export const initialState = {
  isFetchingWallets: false,
  wallets: [],
  locationId: null,
  isFetchingLedger: false,
  isFetchingLedgerMore: false,
  ledger: [],
  ledgerMeta: {},
  plans: [],
  lastWalletCategory: null,
  isFetchingPlans: false,
  isStartingCheckout: false,
  checkingOutPlanId: null,
  isCompletingCheckout: false,
};

const AICreditsReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case FETCH_AI_WALLETS:
        draft.isFetchingWallets = true;
        break;
      case FETCH_AI_WALLETS_SUCCESS:
        draft.isFetchingWallets = false;
        draft.wallets = action.payload?.wallets ?? [];
        draft.locationId = action.payload?.location_id ?? null;
        break;
      case FETCH_AI_WALLETS_FAILURE:
        draft.isFetchingWallets = false;
        draft.wallets = [];
        break;

      case FETCH_AI_LEDGER:
        if (action.append) draft.isFetchingLedgerMore = true;
        else draft.isFetchingLedger = true;
        break;
      case FETCH_AI_LEDGER_SUCCESS: {
        draft.isFetchingLedger = false;
        draft.isFetchingLedgerMore = false;
        const rows = action.payload?.data ?? [];
        draft.ledger = action.append ? [...draft.ledger, ...rows] : rows;
        draft.ledgerMeta = action.payload?.meta ?? {};
        break;
      }
      case FETCH_AI_LEDGER_FAILURE:
        draft.isFetchingLedger = false;
        draft.isFetchingLedgerMore = false;
        if (!action.append) {
          draft.ledger = [];
          draft.ledgerMeta = {};
        }
        break;

      case FETCH_AI_PLANS: {
        const nextCategory = action.payload?.category ?? null;
        draft.isFetchingPlans = true;
        if (nextCategory && nextCategory !== draft.lastWalletCategory) {
          draft.plans = [];
        }
        if (nextCategory) {
          draft.lastWalletCategory = nextCategory;
        }
        break;
      }
      case FETCH_AI_PLANS_SUCCESS: {
        draft.isFetchingPlans = false;
        const nextPlans = Array.isArray(action.payload)
          ? action.payload
          : Array.isArray(action.payload?.data)
            ? action.payload.data
            : [];
        draft.plans = nextPlans;
        break;
      }
      case FETCH_AI_PLANS_FAILURE:
        draft.isFetchingPlans = false;
        draft.plans = [];
        break;

      case START_AI_CHECKOUT:
        draft.isStartingCheckout = true;
        draft.checkingOutPlanId = action.payload?.package_id ?? null;
        break;
      case START_AI_CHECKOUT_SUCCESS:
      case START_AI_CHECKOUT_FAILURE:
        draft.isStartingCheckout = false;
        draft.checkingOutPlanId = null;
        break;

      case COMPLETE_AI_CHECKOUT:
        draft.isCompletingCheckout = true;
        break;
      case COMPLETE_AI_CHECKOUT_SUCCESS:
      case COMPLETE_AI_CHECKOUT_FAILURE:
        draft.isCompletingCheckout = false;
        break;

      default:
        return state;
    }
  });

export default AICreditsReducer;
